const config = {
  API_URL: "/chatbot/api",
  APP_ID: "wx941ddab6f4331e0b",
};

export default config